<template>
  <div class="car-manage">
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="1" ref="BLM-search">
        <el-form-item prop="createTime" label="创建时间">
          <el-date-picker
            v-model="searchData.createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="completeTime" label="完成时间">
          <el-date-picker
            v-model="searchData.completeTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="discardTime" label="作废时间">
          <el-date-picker
            v-model="searchData.discardTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="收款状态" prop="state">
          <el-select
            v-model="searchData.state"
            clearable
            placeholder="请选择收款状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in batchStateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="id" label="收款ID">
          <el-input
            v-number:integer
            v-model="searchData.id"
            placeholder="请输入收款ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="payMethod">
          <el-select
            v-model="searchData.payMethod"
            clearable
            placeholder="请选择支付方式"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in payMethodList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              type="primary"
              @click="searchHandle"
            >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="reset('search')">重置</el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <QS-common-table
      :loading="oLoading.search"
      :data="carDataList"
      :columns="headData"
      :pagination="paginationData"
      @change="paginationChange"
    />
    <!-- 作废 -->
    <dialogWrap
      v-model="oShow.Invalid"
      title="提示"
      width="500px"
      custom-class="dialog-message"
      @onClose="handleCancel"
    >
      <div class="mb-20">收款记录作废后将同步作废相关收款单，应收单需重新进行收款操作。</div>
      <div v-if="DingTalkShow20">
        <el-form
          ref="deleteReasonform"
          :model="deleteReasonform"
          label-width="120px"
          size="small"
          :rules="deleteReasonrules"
        >
          <el-form-item label="作废备注原因："  prop="discardReason">
            <el-input
              type="textarea"
              maxlength="1000"
              v-model="deleteReasonform.discardReason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button
          :loading="oLoading.state"
          size="small"
          type="primary"
          v-submitDingTalkShow="20"
          @click="submitInvalidHandle"
        >确认</el-button>
      </template>
    </dialogWrap>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import {
  batchReceivableRecordDiscard,
  getbatchCollectionRecordList,
} from '@/api/financeApi'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import listMixin from '@/pages/finance/batchCollectionRecord/minxins/list'
import { operateMaxShowLength } from '@/store/dict/config'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  mixins: [listMixin],
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      DingTalkShow20: false,
      deleteReasonform: { discardReason: '' }, // 作废备注原因
      deleteReasonrules: {
        discardReason: [
          { required: true, message: '请填写作废备注原因', trigger: 'blur' },
        ],
      },
      oShow: {
        Invalid: false,
      },
      Invalid: '',
      oLoading: {
        search: false,
        state: false,
      },
      customerList: [],
      searchData: {
        type: 1, // 类别 1收款/2付款（写死）
        createTime: [], // 创建时间
        completeTime: [], // 完成时间
        discardTime: [], // 作废时间
        state: '', // 批量收款状态
        customerType: '', // 付款方类型 // 服务商：1, 客户: 2
        customerId: '', // 付款方
        receivableAccountId: '', // 收款账户
        paymentAccount: '', // 付款账户
        id: '', // 批量收款ID
        payMethod: '', // 支付方式
        deptIdList: [],
      },
      carDataList: [],
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.getBatchCollectionRecordList()
  },
  computed: {
    // 租金收款方式
    payMethodList() {
      return this.dictParseList(selectOption.payMethods)
    },
    batchStateList() {
      return this.dictParseList(selectOption.batchStateDict)
    },
  },
  methods: {
    init() {
      this.headData.push({
        name: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        type: 'operate',
        getOperateList: ({ row }) => {
          const arr = [
            {
              name: 'handelInvalid',
              label: '作废',
              permission:
                Number(row.payMethod) === 10 &&
                row.state === 1 &&
                this.judgePermission('finance_batch_receivable_record_discard'),
              action: () => this.handelInvalid(row.id),
            },
          ]
          return arr.filter((i) => i.permission)
        },
      })
    },
    resetDeleteReasonForm() {
      if (this.DingTalkShow20) {
        this.deleteReasonform.discardReason = ''
        this.$refs?.deleteReasonform?.resetFields()
      }
    },
    // 取消弹窗
    handleCancel() {
      this.oShow.Invalid = false
      this.resetDeleteReasonForm()
    },
    // 作废确认
    async submitInvalidHandle() {
      if (this.oLoading.state) return
      this.oLoading.state = true
      try {
        if (this.DingTalkShow20) {
          const valid = await this.$refs?.deleteReasonform?.validate()
          if (!valid) {
            this.$message.warning('请填写作废原因！')
            return
          }
        }
        const { code } = await batchReceivableRecordDiscard({
          id: this.Invalid,
          discardReason: this.deleteReasonform.discardReason,
        })
        if (code !== 1) return
        this.oShow.Invalid = false
        this.resetDeleteReasonForm()
        this.searchHandle()
      } finally {
        this.oLoading.state = false
      }
    },

    // 搜索事件
    searchHandle() {
      this.paginationData.pageNum = 1
      this.getBatchCollectionRecordList()
    },
    // 获取列表数据
    getBatchCollectionRecordList() {
      this.oLoading.search = true
      let createStartDate = null // 创建开始日期
      let createEndDate = null // 创建结束日期
      if (
        this.searchData.createTime instanceof Array &&
        this.searchData.createTime.length
      ) {
        createStartDate = this.searchData.createTime[0] || null
        createEndDate = this.searchData.createTime[1] || null
      }
      let completeStartDate = null // 完成开始日期
      let completeEndDate = null // 完成结束日期
      if (
        this.searchData.completeTime instanceof Array &&
        this.searchData.completeTime.length
      ) {
        completeStartDate = this.searchData.completeTime[0] || null
        completeEndDate = this.searchData.completeTime[1] || null
      }
      let discardStartDate = null // 作废开始日期
      let discardEndDate = null // 作废结束日期
      if (
        this.searchData.discardTime instanceof Array &&
        this.searchData.discardTime.length
      ) {
        discardStartDate = this.searchData.discardTime[0] || null
        discardEndDate = this.searchData.discardTime[1] || null
      }
      getbatchCollectionRecordList({
        ...this.searchData,
        customerId: Number(this.searchData.customerId) || null,
        createStartDate,
        createEndDate,
        completeStartDate,
        completeEndDate,
        discardStartDate,
        discardEndDate,
        pageSize: this.paginationData.pageSize,
        pageNum: this.paginationData.pageNum,
      }).then((res) => {
        const { code, data } = res
        if (code !== 1) {
          return
        }
        if (data.items && data.items.length) {
          this.carDataList = data.items
          this.paginationData.total = data.totalNum
        } else {
          this.carDataList = []
          this.paginationData.total = 0
        }
      }).finally(() => {
        this.oLoading.search = false
      })
    },
    // 作废
    handelInvalid(id) {
      this.oShow.Invalid = true
      this.Invalid = id
    },
    // 清空然后搜索
    reset(form) {
      this.$refs[form].resetFields()
      this.searchHandle()
      this.customerList = []
    },
    // 查看详情
    // eslint-disable-next-line vue/no-unused-properties
    viewDetails(row) {
      const { id, payMethod } = row
      if (payMethod === 20) {
        this.$router.push({
          path:
            '/finance/batchCollectionRecord/batchCollectionRecordDetailOnline',
          query: { id },
        })
      } else {
        this.$router.push({
          path: '/finance/batchCollectionRecord/batchCollectionRecordDetails',
          query: { id },
        })
      }
    },
  },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.operation-box {
  margin: 16px 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
}

.customerInfo {
  ::v-deep .el-input--small {
    width: 200px;
  }
}

.customer {
  display: flex;
  flex-direction: row;
  &-name {
    // float: left;
    width: 80px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  &-phone {
    // float: left;
    color: #8492a6;
    font-size: 13px;
    margin: 0;
    padding-left: 20px;
  }
}
</style>
